<template>
    <el-button
    type="primary"
    size="mini"
    icon="el-icon-download"
    @click="handleCsvDownload"
    style="margin-right: 10px;"
    :loading="downloadingCsv">
    {{$t('common.csv')}}
    </el-button>
</template>
<script>
import constants from '@/utils/constants';
import { DOS_CSV } from '@/store/actions';

export default {
  name: 'DownloadCsv',
  data() {
    return {
      downloadingCsv: false,
      daysOfWeekSelected: [],
    };
  },
  computed: {
    daysOfWeek() {
      return constants.DAY_OF_SERVICE.DAYS_OF_WEEK;
    }
  },
  methods: {
    handleCsvDownload() {
      this.downloadingCsv = true;
      const daysOfWeekToSend = {};
      for (const dow of this.daysOfWeek) {
        daysOfWeekToSend[dow.value] = this.daysOfWeekSelected.some(dowSelected => dow.value === dowSelected);
      }
      this.$store.dispatch(DOS_CSV, { ...daysOfWeekToSend })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          // Updated to xlsx
          link.setAttribute('download', 'day_of_service_shipper_report.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.downloadingCsv = false;
        })
        .catch(() => {
          this.downloadingCsv = false;
        });
    }

  },
};
</script>
